import { render, staticRenderFns } from "./change-qq-dialog.vue?vue&type=template&id=3bdb913c&"
import script from "./change-qq-dialog.vue?vue&type=script&lang=js&"
export * from "./change-qq-dialog.vue?vue&type=script&lang=js&"
import style0 from "./change-qq-dialog.vue?vue&type=style&index=0&id=3bdb913c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports